import Card5Palace from "../Previews/Card5Palace/Preview";
import PreviewPalace from "../Previews/PreviewPalace/Preview";
import ShipBannerPreview from "../Previews/Ship/Banner/Preview";
import TermsPreview from "../Previews/Ship/Terms/Preview";
import TablePreview from "../Previews/TablePreview/Preview";
import TablePreview2 from "../Previews/TablePreview2/Preview";
import TablePreview3 from "../Previews/TablePreview3/Preview";
import TablePreview4 from "../Previews/TablePreview4/Preview";
import TablePreview5 from "../Previews/TablePreview5/Preview";

export const PrepareForYourCruisePage = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 2,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "English Sub Title",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Sub Title",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Sub Title",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Sub Title",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
        },
      ],
      level1: [
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },

        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },
      ],
      preview: (activetab, cardData) => (
        <TablePreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [
        {
          title: "English Sub Title",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Sub Title",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Sub Title",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Sub Title",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
        },
      ],
      level1: [
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },

        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },
      ],
      preview: (activetab, cardData) => (
        <TablePreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [
        {
          title: "English Sub Title",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Sub Title",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Sub Title",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Sub Title",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Table Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Table Image",
          type: "file",
          withAlt: true,
          required: false,
        },
      ],
      level1: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
        },

        {
          title: "English Price (Genting Dream)",
          key: "price_genting",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Price (Genting Dream)",
          key: "simplified_chinese_price_genting",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Price (Genting Dream)",
          key: "traditional_chinese_price_genting",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Price (Genting Dream)",
          key: "bahasa_price_genting",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "English Price (Star Navigator)",
          key: "price_resort",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Price (Star Navigator)",
          key: "simplified_chinese_price_resort",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Price (Star Navigator)",
          key: "traditional_chinese_price_resort",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Price (Star Navigator)",
          key: "bahasa_price_resort",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "English Price (Star Voyager)",
          key: "price_star",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Price (Star Voyager)",
          key: "simplified_chinese_price_star",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Price (Star Voyager)",
          key: "traditional_chinese_price_star",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Price (Star Voyager)",
          key: "bahasa_price_star",
          className: "col-lg-3",
          type: "input",
        },
      ],
      preview: (activetab, cardData) => (
        <TablePreview2 activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [
        {
          title: "English Sub Title",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Sub Title",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Sub Title",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Sub Title",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
        },
      ],
      level1: [
        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
        },
      ],
      preview: (activetab, cardData) => (
        <TablePreview3 activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 3,
      fields: [
        {
          title: "English Sub Title",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Sub Title",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Sub Title",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Sub Title",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
        },
      ],
      level1: [
        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
        },
      ],
      level2: [
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-3",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },

        {
          title: "Simplified Chinese Image",
          key: "simplified_chinese_image",
          placeholder: "Upload Card Image",
          className: "col-lg-3",
          type: "file",
          withAlt: true,
        },
        {
          title: "Traditional Chinese Image",
          key: "traditional_chinese_image",
          className: "col-lg-3",
          type: "file",
          withAlt: true,
          placeholder: "Upload Card Image",
        },
        {
          title: "Bahasa Image",
          key: "bahasa_image",
          className: "col-lg-3",
          type: "file",
          withAlt: true,
          placeholder: "Upload Card Image",
        },

        {
          title: "English Sub Title",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Sub Title",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese Sub Title",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa Sub Title",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
        },
      ],
      preview: (activetab, cardData) => (
        <TablePreview4 activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [
        {
          title: "English Sub Title",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Sub Title",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Sub Title",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Sub Title",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
        },
      ],
      level1: [
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
        },
      ],
      preview: (activetab, cardData) => (
        <TablePreview5 activetab={activetab} cardData={cardData} />
      ),
    },
  ],
};
